import types from '../types/start'
import orchestratorTypes from '../types/orchestrator'
import {Map, List} from 'immutable'

const initialRoot = Map({
  rent: null,
  transaction: null,
  items: List(),
  willReturnItems: false,
  isFetching: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case orchestratorTypes.START:
      return initialRoot.merge({
        items: List([action.payload.item]),
      })
    case types.CREATE_SELF_RENT:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.CREATE_SELF_RENT_SUCCESS:
      return state.merge({
        rent: Map(action.payload.rent),
        isFetching: false,
        error: '',
      })
    case types.CREATE_SELF_RENT_FAIL:
      return state.merge({
        rent: null,
        isFetching: false,
        error: action.payload.error,
      })
    case types.CREATE_RETURN_TRANSACTION:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.CREATE_RETURN_TRANSACTION_SUCCESS:
      return state.merge({
        transaction: action.payload.transaction,
        isFetching: false,
        error: '',
      })
    case types.CREATE_RETURN_TRANSACTION_FAIL:
      return state.merge({
        transaction: null,
        isFetching: false,
        error: action.payload.error,
      })
    case types.SET_WILL_RETURN_ITEMS:
      return state.merge({
        willReturnItems: action.payload.willReturnItems,
      })
    case types.ADD_ITEM:
      if (typeof state.get('items').find(item => item.get('ID') === action.payload.item.get('ID')) === 'undefined') {
        return state.merge({
          items: state.get('items').push(action.payload.item),
        })
      } else {
        return state
      }
    case types.REMOVE_ITEM:
      return state.merge({
        items: state.get('items').filter(item => item.get('ID') !== action.payload.itemID),
      })
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/remove/reducers/start.js